import * as React from 'react';

const Box24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12 15.75a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h17A1.5 1.5 0 0 1 22 4.5v3A1.5 1.5 0 0 1 20.5 9h-.063q.062.24.063.5V19a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V9.5q0-.26.063-.5H3.5A1.5 1.5 0 0 1 2 7.5zM5.5 9a.5.5 0 0 0-.5.5V19a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V9.5a.5.5 0 0 0-.5-.5zm15-1.5v-3h-17v3z"
  }
));
Box24.Size = 24;
Box24.Title = "Box";

export { Box24 as default };
